var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
/**
 * Higher order component (HOC) that allows any other component to monitor view
 * state.
 *
 * Provides props viewWidth, viewHeight.
 */

export var provideViewSize = function provideViewSize(WrappedComponent) {
  return function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this));

      _this.handleViewSizeChange = _this.handleViewSizeChange.bind(_this);
      _this.state = {
        viewWidth: window.innerWidth,
        viewHeight: window.innerHeight
      };
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      window.addEventListener("resize", this.handleViewSizeChange);
    };

    _class.prototype.componentWillUnmount = function componentWillUnmount() {
      window.removeEventListener("resize", this.handleViewSizeChange);
    };

    _class.prototype.handleViewSizeChange = function handleViewSizeChange() {
      this.setState({
        viewWidth: window.innerWidth,
        viewHeight: window.innerHeight
      });
    };

    _class.prototype.render = function render() {
      return React.createElement(WrappedComponent, _extends({
        viewHeight: this.state.viewHeight,
        viewWidth: this.state.viewWidth
      }, this.props));
    };

    return _class;
  }(React.Component);
};